"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _get2 = _interopRequireDefault(require("lodash/get"));

var _react = require("react");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _recompose = require("recompose");

var _en_GB = _interopRequireDefault(require("./locales/en_GB"));

var mergeObject = function mergeObject(list) {
  return list.reduce(function (a, b) {
    a = (0, _extends2.default)({}, a, b);
    return a;
  }, {});
};

var withLocale = function withLocale(combineKeys) {
  if (combineKeys === void 0) {
    combineKeys = [];
  }

  return function (BaseComponent) {
    var factory = (0, _react.createFactory)(BaseComponent);

    var WithLocale =
    /*#__PURE__*/
    function (_Component) {
      (0, _inheritsLoose2.default)(WithLocale, _Component);

      function WithLocale() {
        return _Component.apply(this, arguments) || this;
      }

      var _proto = WithLocale.prototype;

      _proto.render = function render() {
        var _this$props = this.props,
            innerRef = _this$props.innerRef,
            rest = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["innerRef"]);
        var messages = this.context.rsuiteLocale || _en_GB.default;
        var locales = combineKeys.map(function (key) {
          return (0, _get2.default)(messages, "" + key);
        });
        return factory((0, _extends2.default)({
          ref: innerRef,
          locale: mergeObject(locales)
        }, rest));
      };

      return WithLocale;
    }(_react.Component);

    (0, _defineProperty2.default)(WithLocale, "contextTypes", {
      rsuiteLocale: _propTypes.default.object
    });
    (0, _defineProperty2.default)(WithLocale, "handledProps", []);

    if (process.env.NODE_ENV !== 'production') {
      return (0, _recompose.setDisplayName)((0, _recompose.wrapDisplayName)(BaseComponent, 'withLocale'))(WithLocale);
    }

    return WithLocale;
  };
};

var _default = withLocale;
exports.default = _default;